module.exports = __webpack_public_path__ + "img/bank-transfer.544938b8.png";